import React, { useEffect } from "react";
import { Trash } from "lucide-react";
import { AllowanceDropdown } from "./AllowanceDropdown";
import { useGlobalContext } from "../Context/GlobalContext";

export const EarningsSection = ({ effectiveDate, earnings, setEarnings }) => {
  const { baseUrl, selectedStaff } = useGlobalContext();
  const handleChange = (name, value, field) => {
    setEarnings(
      earnings.map((earning) =>
        earning.name === name ? { ...earning, [field]: value } : earning
      )
    );
  };

  async function createNewEarningField(heads) {
    const data = {};
    console.log(heads);
    const response = await fetch(baseUrl + "earnings/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        staffId: selectedStaff?.staffDetails?.id,
        heads: heads,
        salary_month: effectiveDate,
      }), // send the formatted data
    });

    console.log(response);

    if (response.status === 201) {
      const result = await response.json();
      console.log(result);
      setEarnings(
        earnings.map((earning) =>
          earning.name === heads ? { ...earning, id: result.data.id } : earning
        )
      );
      // alert("edit Custom Field Successfully");
    } else {
      // alert("An error occurred");
    }
  }
  async function deleteEarningField(id) {
    const response = await fetch(baseUrl + "earnings/delete/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log(response);

    if (response.status === 201) {
      const result = await response.json();
      console.log(result);
      // alert("edit Custom Field Successfully");
    } else {
      // alert("An error occurred");
    }
  }
  useEffect(() => {
    if (earnings.length > 0) {
      createNewEarningField(earnings[earnings.length - 1]?.name);
    }
  }, [earnings.length, effectiveDate]);
  const renderMobileView = () => (
    <div className="space-y-4">
      {earnings.map((earning, index) => (
        <div
          key={index}
          className="bg-white rounded-md p-4 border border-gray-200"
        >
          <label className="block text-sm font-medium text-[#3A3541] mb-2">
            {earning.name}
          </label>
          <div className="space-y-2">
            <div className="relative">
              <select
                disabled={true}
                value={earning.type}
                onChange={(e) =>
                  handleChange(earning.name, e.target.value, "type")
                }
                className="w-full px-3 py-1.5 text-sm font-normal text-[#3A3541] border border-gray-200 rounded-md focus:outline-none appearance-none bg-gray-50 disabled:bg-[#f5f5f5] disabled:cursor-not-allowed"
              >
                <option value="On Attendance">On Attendance</option>
                <option value="Flat Rate">Flat Rate</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="relative flex-1">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                  ₹
                </span>
                <input
                  type="text"
                  value={earning.amount}
                  onChange={(e) =>
                    handleChange(earning.name, e.target.value, "amount")
                  }
                  placeholder="0"
                  className="w-full pl-7 pr-3 py-1.5 text-sm font-normal text-[#3A3541] border border-gray-200 rounded-md focus:outline-none focus:border-blue-500"
                />
              </div>
              <button
                onClick={() => {
                  setEarnings(
                    earnings.filter((item) => item.name !== earning.name)
                  );
                  deleteEarningField(earning.id);
                }}
                className="p-1.5 border border-gray-200 rounded-md"
              >
                <Trash className="w-4 h-4 text-red-500" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const renderTableView = () => (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr>
            <th className="text-sm font-medium w-[316px] text-left pb-3  text-[#3A3541]">
              Heads
            </th>
            <th className="text-sm font-medium text-left pb-3 w-1/3 text-[#3A3541]">
              Calculation
            </th>
            <th className="text-sm font-medium text-right pb-3 text-[#3A3541]">
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          {earnings.length === 0 ? (
            <tr>
              <td
                colSpan={3}
                className="py-4 text-sm text-gray-600 font-normal"
              >
                No Earnings Added
              </td>
            </tr>
          ) : (
            earnings.map((earning, index) => (
              <tr key={index} className="group">
                <td className="py-2">
                  <span className="text-sm font-normal text-[#3A3541]">
                    {earning.name}
                  </span>
                </td>
                <td className="py-2">
                  <div className="relative w-[160px]">
                    <select
                      // disabled={true}
                      value={earning.type}
                      onChange={(e) =>
                        handleChange(earning.name, e.target.value, "type")
                      }
                      className="w-full salary-detailcs text-sm font-normal text-[#3A3541] border rounded-md focus:outline-none appearance-none bg-white disabled:bg-[#fff] disabled:cursor-not-allowed border-gray-300"
                    >
                      <option className="" value="On Attendance">
                        On Attendance
                      </option>
                      <option value="Flat Rate">Flat Rate</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                      <svg
                        className="w-4 h-4 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </td>
                <td className="py-2">
                  <div className="flex items-center justify-end gap-2">
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#3A3541]">
                        ₹
                      </span>
                      <input
                        type="text"
                        value={earning.amount}
                        onChange={(e) =>
                          handleChange(earning.name, e.target.value, "amount")
                        }
                        placeholder="0"
                        className="w-[160px] pl-[26px] bg-white placeholder:text-[#3A3541]  text-right salary-detailcs text-sm font-normal text-[#3A3541] border border-gray-200 rounded-md focus:outline-none "
                      />
                    </div>
                    <button
                      className="absolute  right-[-2px]"
                      onClick={() => {
                        setEarnings(
                          earnings.filter((item) => item.name !== earning.name)
                        );
                        deleteEarningField(earning.id);
                      }}
                    >
                      <Trash className="w-4 h-4 text-red-500" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="w-full">
      <div className="bg-[#F4F5F9] px-6 py-3 rounded-md">
        <h2 className="text-lg font-medium text-[#3A3541]">Earnings</h2>
      </div>

      <div className="p-[20px] pb-[0]">
        <div className="sm:hidden">{renderMobileView()}</div>
        <div className="hidden sm:block">{renderTableView()}</div>
        <AllowanceDropdown earnings={earnings} setEarnings={setEarnings} />
        {/* <button
          onClick={() => setEarnings([...earnings, { name: 'New Allowance', type: 'On Attendance', amount: '' }])}
          className="mt-4 text-sm text-blue-500 hover:text-blue-600 font-normal flex items-center gap-1"
        >
          <span>+</span> Add Allowance
        </button> */}
      </div>
    </div>
  );
};
